var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
// AUTO-GENERATED CONTENT - DO NOT MANUALLY EDIT - Run 'yarn generate:assets' to update
import Asset from '../asset-internal';
function ScalaLogomark(_a) {
    var restProps = __rest(_a, []);
    return (_jsx(Asset, Object.assign({ viewBox: "0 0 40 40" }, restProps, { children: _jsx("path", { fill: "currentColor", d: "M29.231 4v7.385s0 3.077-18.462 4.923V8.923S29.231 7.077 29.231 4zM10.769 18.769s18.462-1.846 18.462-4.923v7.385s0 3.077-18.462 4.923v-7.385zm0 9.847V36c18.462-1.846 18.462-4.923 18.462-4.923v-7.385c0 3.077-18.462 4.924-18.462 4.924z", fillRule: "evenodd", clipRule: "evenodd" }) })));
}
export default ScalaLogomark;
